/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_NamespaceInputs */

const id_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ms_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const da_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const de_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const en_us2_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const es_es2_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const es_mx2_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fil_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fr_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const it_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const hu_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const nl_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const no_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pl_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pt_br2_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pt_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ro_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fi_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const sv_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const vi_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const tr_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const cs_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const bg_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ru_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пространство имён`)
};

const uk_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ar_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const hi_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेमस्पेस`)
};

const th_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ja_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const zh_cn2_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命名空间`)
};

const zh_hant1_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命名空間`)
};

const ko_items_table_namespace = /** @type {(inputs: Items_Table_NamespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

/**
* | output |
* | --- |
* | "Namespace" |
*
* @param {Items_Table_NamespaceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_namespace = /** @type {((inputs?: Items_Table_NamespaceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_NamespaceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_namespace(inputs)
	if (locale === "ms") return ms_items_table_namespace(inputs)
	if (locale === "da") return da_items_table_namespace(inputs)
	if (locale === "de") return de_items_table_namespace(inputs)
	if (locale === "en-US") return en_us2_items_table_namespace(inputs)
	if (locale === "es-ES") return es_es2_items_table_namespace(inputs)
	if (locale === "es-MX") return es_mx2_items_table_namespace(inputs)
	if (locale === "fil") return fil_items_table_namespace(inputs)
	if (locale === "fr") return fr_items_table_namespace(inputs)
	if (locale === "it") return it_items_table_namespace(inputs)
	if (locale === "hu") return hu_items_table_namespace(inputs)
	if (locale === "nl") return nl_items_table_namespace(inputs)
	if (locale === "no") return no_items_table_namespace(inputs)
	if (locale === "pl") return pl_items_table_namespace(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_namespace(inputs)
	if (locale === "pt") return pt_items_table_namespace(inputs)
	if (locale === "ro") return ro_items_table_namespace(inputs)
	if (locale === "fi") return fi_items_table_namespace(inputs)
	if (locale === "sv") return sv_items_table_namespace(inputs)
	if (locale === "vi") return vi_items_table_namespace(inputs)
	if (locale === "tr") return tr_items_table_namespace(inputs)
	if (locale === "cs") return cs_items_table_namespace(inputs)
	if (locale === "bg") return bg_items_table_namespace(inputs)
	if (locale === "ru") return ru_items_table_namespace(inputs)
	if (locale === "uk") return uk_items_table_namespace(inputs)
	if (locale === "ar") return ar_items_table_namespace(inputs)
	if (locale === "hi") return hi_items_table_namespace(inputs)
	if (locale === "th") return th_items_table_namespace(inputs)
	if (locale === "ja") return ja_items_table_namespace(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_namespace(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_namespace(inputs)
	return ko_items_table_namespace(inputs)
});
export { items_table_namespace as "items.table.namespace" }